import React from 'react';

const AlreadyHeart = () => {
   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width='24'
         height='24'
         viewBox='0 0 24 24'
         role='img'
         aria-hidden='true'
         className='crayons-icon'
      >
         <title>Heart</title>
         <path
            fill='rgb(220 38 38)'
            d='M2.821 12.794a6.5 6.5 0 017.413-10.24h-.002L5.99 6.798l1.414 1.414 4.242-4.242a6.5 6.5 0 019.193 9.192L12 22l-9.192-9.192.013-.014z'
         ></path>
      </svg>
   );
};

export default AlreadyHeart;
